export default "__VITE_ASSET__ccc89007__"